import { object, string, uuid, email } from "./schemas.js";
import { domain } from "./regexes.js";
import { ZodError } from "./errors.js";
import { prettifyError } from "./errors2.js";
const CACHE_VERSION = "v1";
function getCache() {
  window._bynderSharedPortalAndUserData = window._bynderSharedPortalAndUserData || {};
  window._bynderSharedPortalAndUserData.cache = window._bynderSharedPortalAndUserData.cache || {};
  window._bynderSharedPortalAndUserData.cache[CACHE_VERSION] = window._bynderSharedPortalAndUserData.cache[CACHE_VERSION] || {};
  return window._bynderSharedPortalAndUserData.cache[CACHE_VERSION];
}
function setInCache(key, data) {
  var _a;
  const cache = getCache();
  const existingData = ((_a = cache[key]) == null ? void 0 : _a.data) || {};
  cache[key] = {
    data: {
      ...existingData,
      ...data
    },
    updatedAt: Date.now()
  };
}
function getFromCache(key) {
  const cache = getCache();
  return cache[key];
}
function deduplicateRequest(key, requester) {
  window._bynderSharedPortalAndUserData = window._bynderSharedPortalAndUserData || {};
  window._bynderSharedPortalAndUserData.requests = window._bynderSharedPortalAndUserData.requests || {};
  const ongoingRequest = window._bynderSharedPortalAndUserData.requests[key];
  if (ongoingRequest) {
    return ongoingRequest.then((response) => response.clone());
  }
  const newRequest = requester();
  window._bynderSharedPortalAndUserData.requests[key] = newRequest;
  return newRequest.finally(() => {
    var _a;
    if ((_a = window._bynderSharedPortalAndUserData) == null ? void 0 : _a.requests) {
      delete window._bynderSharedPortalAndUserData.requests[key];
    }
  });
}
object({
  portal_id: uuid(),
  name: string(),
  domain: string().regex(domain),
  date_created: string()
});
const CACHE_KEY = "userData";
const CACHE_TTL = 10 * 60 * 1e3;
const UserDataResponseSchema = object({
  id: uuid(),
  email: email()
});
async function getUserData() {
  const cachedEntry = getFromCache(CACHE_KEY);
  if (cachedEntry && Date.now() - cachedEntry.updatedAt < CACHE_TTL) {
    return cachedEntry.data;
  }
  try {
    const response = await deduplicateRequest(
      "/v7/identity/users/current_user/",
      () => fetch("/v7/identity/users/current_user/")
    );
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    const user = UserDataResponseSchema.parse(data);
    const userData = {
      id: user.id,
      email: user.email
    };
    setInCache(CACHE_KEY, userData);
    return userData;
  } catch (error) {
    if (error instanceof ZodError) {
      console.error("getUserData: Error parsing user data:", prettifyError(error));
    } else {
      console.error("getUserData: Error fetching user data:", error);
    }
    if (cachedEntry) {
      return cachedEntry.data;
    }
    return void 0;
  }
}
export {
  getUserData
};
//# sourceMappingURL=index2.js.map
